import { useNavigate } from "react-router-dom";
import { useState } from "react";

import ExhibitorEventForm from "components/exhibitorEvents/ExhibitorEventForm";
import { createExhibitorEvent } from "api/exhibitorEvent.api";
import Alert from "components/common/Alert";

export default function CreateExhibitorEvent() {
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);

  const userId = "69579c6190a653b640e65639";

  return (
    <>
      {alert && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}

      <ExhibitorEventForm
        onSubmit={async (payload) => {
          try {
            if (payload instanceof FormData) {
              payload.append("created_by", userId);
            } else {
              payload.created_by = userId;
            }

            await createExhibitorEvent(payload);
            navigate("/admin/exhibitor-events");
          } catch (error) {
            setAlert({
              type: "error",
              message:
                error.response?.data?.message ||
                "Failed to create exhibitor event",
            });
          }
        }}
        onBack={() => navigate("/admin/exhibitor-events")}
      />
    </>
  );
}
